import { render, staticRenderFns } from "./station.vue?vue&type=template&id=388756f3&scoped=true"
import script from "./station.vue?vue&type=script&lang=js"
export * from "./station.vue?vue&type=script&lang=js"
import style0 from "./station.vue?vue&type=style&index=0&id=388756f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388756f3",
  null
  
)

export default component.exports